"use-client";
import { Dialog as t, ark as i } from "@ark-ui/react";
import { styled as r } from "@huspy/styled-system/jsx";
import { drawer as a } from "@huspy/styled-system/recipes";
import { createStyleContext as s } from "../../utils/createStyleContext.mjs";
const { withRootProvider: n, withContext: e } = s(a), d = n(t.Root), c = e(r(t.Backdrop), "backdrop"), p = e(r(i.div), "body"), D = e(r(t.CloseTrigger), "closeTrigger"), g = e(r(t.Content), "content"), l = e(r(t.Description), "description"), w = e(r(i.div), "footer"), m = e(r(i.div), "header"), y = e(r(t.Positioner), "positioner"), T = e(r(t.Title), "title"), C = e(r(t.Trigger), "trigger"), o = {
  Root: d,
  Backdrop: c,
  Body: p,
  CloseTrigger: D,
  Content: g,
  Description: l,
  Footer: w,
  Header: m,
  Positioner: y,
  Title: T,
  Trigger: C
};
o.Backdrop.displayName = "DrawerBackdrop";
o.Body.displayName = "DrawerBody";
o.CloseTrigger.displayName = "DrawerCloseTrigger";
o.Content.displayName = "DrawerContent";
o.Description.displayName = "DrawerDescription";
o.Footer.displayName = "DrawerFooter";
o.Header.displayName = "DrawerHeader";
o.Positioner.displayName = "DrawerPositioner";
o.Title.displayName = "DrawerTitle";
o.Trigger.displayName = "DrawerTrigger";
export {
  o as Drawer,
  c as DrawerBackdrop,
  p as DrawerBody,
  D as DrawerCloseTrigger,
  g as DrawerContent,
  l as DrawerDescription,
  w as DrawerFooter,
  m as DrawerHeader,
  y as DrawerPositioner,
  d as DrawerRoot,
  T as DrawerTitle,
  C as DrawerTrigger
};
